import { tokenPocket, tokenPocketDark } from "../../../utils";

export default {
  product: {
    title: 'Product',
    label_1: 'KeyPal',
    label_2: 'Secret Box',
    label_3: 'Leather Case',
    label_4: 'All Accessories',
  },
  upgrade: {
    label_1: 'Upgrade',
  },
  // learn标题下面的描述我不知道是什么文案
  learn: {
    label_1: 'Security',
  },
  others: {
    label_1: 'Abouts',
    label_2: 'Privacy Policy',
    label_3: 'Terms Of Use',
  },
  support: {
    title: 'Support',
    label_1: 'Help Center',
    label_2: 'FAQ For Purchase',
    label_3: 'Community',
  },
  cryptoAssets: {
    title: 'Crypto Assets',
    label_1: 'Bitcoin Wallet',
    label_2: 'Ethereum Wallet',
    label_3: 'Solana Wallet',
    label_4: 'Tron Wallet',
    label_5: 'Stablecoin Wallet',
  }, 
  getStarted: {
    title: 'Get Started',
    label_1: 'How to keep your wallet safe?',
    label_2: 'How to use KeyPal 2?',
    label_3: 'How to use KeyPal Card?',
    label_4: 'How to use KeyPal Plus?',
    label_5: 'How to use Secret Box?',
  }, 
  download: {
    title: 'Download',
    label_1: 'Mobile Wallet',
    label_2: 'Extension Wallet',
    label_3: 'Upgrade',
  }, 
  legal: {
    title: 'Legal',
    label_1: 'Privacy Policy',
    label_2: 'Terms of Use',
  }, 

  designed: `Designed by ${tokenPocket} with ❤️`,
  designedDark: `Designed by ${tokenPocketDark} with ❤️`,
}
